import React from 'react';
import PropTypes from 'prop-types';
import { sectionPaddingClasses } from '../../helpers/prismicHelpers/prismic-slice-helpers/PrismicSliceHelpers';

export default function MultipleMediaSlice(props) {

    const {
        title,
        button_title,
        button_url,
        margins,
        media
    } = props.content;

    const mediaImage = (singleMedia, index) => {
        return (
            <div className="col-xs-12 col-md-4 col-xl-3" key={index}>
                <img src={singleMedia.image} alt={singleMedia.image_alternative} className="img-fluid padding-xy" />
                <h4 className="h4">{singleMedia.title}</h4>
                <p className="p-tag">{singleMedia.description}</p>
            </div>
        )
    }

    const mediaYoutube = (singleMedia, index) => {
        return (
            <div className="col-xs-12 col-md-4 col-xl-3" key={index}>
                <div dangerouslySetInnerHTML={{ __html: singleMedia.youtube.html }} />
                <h4 className="h4">{singleMedia.title}</h4>
                <p className="p-tag">{singleMedia.description}</p>
            </div>
        )
    }

    const mediaWistia = (singleMedia, index) => {
        return (
            <div className="col-xs-12 col-md-4 col-xl-3" key={index}>
                <div dangerouslySetInnerHTML={{ __html: singleMedia.wistia }} />
                <h4 className="h4">{singleMedia.title}</h4>
                <p className="p-tag">{singleMedia.description}</p>
            </div>
        )
    }

    if(!media || media.length === 0) return '';

    return (
        <section className={sectionPaddingClasses(margins)}>
            <div className="container text-center">
                {title && <h2 className="h2 text-center padding-bottom">{title}</h2>}
                <div className="row">
                    {
                        media.map((singleMedia, index) => {
                            if (singleMedia.media_type === 'image') return mediaImage(singleMedia, index)
                            if (singleMedia.media_type === 'youtube') return mediaYoutube(singleMedia, index)
                            if (singleMedia.media_type === 'wistia') return mediaWistia(singleMedia, index)
                            return ''
                        })
                    }
                </div>
                <div className="text-center padding-top">
                    {
                        button_url &&
                        button_title &&
                        <a href={button_url} className="btn btn-primary">{button_title}</a>
                    }
                </div>
            </div>
        </section>
    )
}

MultipleMediaSlice.propTypes = {
    content: PropTypes.shape({
        type: PropTypes.string,
        title: PropTypes.string,
        button_title: PropTypes.string,
        button_url: PropTypes.string,
        media: PropTypes.arrayOf(PropTypes.shape({
            title: PropTypes.string,
            description: PropTypes.string,
            image: PropTypes.string,
            image_alternative: PropTypes.string,
            media_type: PropTypes.string,
            youtube: PropTypes.object,
            wistia: PropTypes.string
        })),
    })
}



// WEBPACK FOOTER //
// src/client/components/slices/MultipleMediaSlice.js